var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-block img-container",
      class: _vm.mainClasses,
      attrs: { id: `img-container-wrapper-${_vm.id}` },
    },
    [
      _c(
        "div",
        { staticClass: "row", class: [_vm.noSpaceBetween ? "no-gutters" : ""] },
        [
          _vm._l(_vm.items, function (img, idx) {
            return [
              _vm.lineBreak(idx) && !_vm.enableMainImage
                ? _c("div", { staticClass: "w-100" })
                : _vm._e(),
              _vm._v(" "),
              _c("image-container", {
                key: `key-${_vm.id}-${idx}`,
                ref: `imageInput${_vm.id}`,
                refInFor: true,
                staticClass: "col",
                class: _vm.imageClasses(idx),
                attrs: {
                  id: `img-container-${_vm.id}`,
                  idUpload: `image-upload-${_vm.id}-${idx + 1}`,
                  disabled: _vm.disabled,
                  imageIndex: idx,
                  maxImage: _vm.maxImage,
                  multiple: _vm.multiple,
                  targetImage: _vm.photos[idx],
                  imageList: _vm.photos,
                  showImageLimitMessage: _vm.showImageLimitMessage,
                  showDeleteButton: _vm.activeDeleteButton,
                  showEditButton: _vm.activeEditButton,
                  accept: _vm.accept,
                  imageClass: _vm.imageClass,
                  capture: _vm.captureMediaAttribute,
                },
                on: {
                  "remove-image": _vm.onRemoveImage,
                  "create-image": _vm.onCreateImage,
                  "update-image": _vm.onUpdateImage,
                  "show-lightbox": _vm.onShowLightbox,
                },
              }),
              _vm._v(" "),
              _vm.lineBreak(idx) && _vm.enableMainImage
                ? _c("div", { staticClass: "w-100" })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.lightBoxVisible
        ? _c("VueEasyLightbox", {
            attrs: {
              visible: _vm.openImage,
              index: _vm.imageIndex,
              imgs: _vm.arrLightBox,
              moveDisabled: false,
            },
            on: { hide: _vm.handleLightboxHide },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }